import { FC } from 'react';

import CommunicationsSidenav from 'modules/communications/components/CommunicationsSidenav';
import { sections } from 'modules/communications/constants/sections';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import CommunicationHeader from './CommunicationHeader';
import CertificationView from './CertificationView';
import CommunicationBody from './CommunicationBody';

const CommunicationDetailsPageBody: FC = () => {
  const { data, actions } = useCommunicationDetailsPage();

  return (
    <div className="nk-content-wrap">
      <div className="nk-ibx">
        <CommunicationsSidenav
          section={sections.INBOX}
          totalUnreadCommunications={data.totalUnreadCommunications}
          handleToggleInboxSection={actions.handleToggleInboxSection}
          handleToggleSettingsSection={actions.handleToggleSettingsSection}
        />

        <div className="nk-ibx-body bg-white overflow-y-auto">
          {data.isCertificationView ? (
            <CertificationView />
          ) : (
            <>
              <CommunicationHeader />

              <CommunicationBody />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommunicationDetailsPageBody;
